import React  from 'react';
import UserComponentProto from './user-proto.jsx';


export default function renderDateInEdit(id, props) {
    return <UserComponentProto renderMode="edit" id={id} {...props} />;
}